const ICONS = {
  1: 'Parking-v2_T',
  2: 'Transporte_publico_T',
  3: 'Alquiler_de_coches_T',
  4: 'Companias_aereas_T',
  5: 'Maletas_T',
  6: 'Llegadas_T',
  7: 'Salidas_T',
  8: 'Tiendas_y_duty_free_T',
  9: 'Restaurantes_y_Cafeterias_T',
  10: 'Sala_VIP_T',
  11: 'FastTrack_T',
  12: 'Devolucion_de_impuestos_T',
  13: 'Cajero_automatico_T',
  14: 'Cambio_moneda_T',
  15: 'Enlaces_relacionados_T',
  16: 'PMR_T',
  17: 'Punto_de_informacion_T',
  18: 'Seguridad_T',
  19: 'Agencias-de-viaje_T',
  20: 'Sala_de_Reuniones_T',
  21: 'Oficina_de_correo_T',
  22: 'Servicios_sanitarios_T',
  23: 'Oratorio_multiconfesional_T',
  24: 'Familia_T',
  25: 'Air-room_T',
  26: 'Aseos_T',
  27: 'Servicios_pasajero_T'
}

export function getCategoryIcon (data) {
  return `categories/${ICONS[data] || 'Ayuda-web-JJ-red'}.svg`
}
